'use strict';

module.exports = "message Propose {\n  optional bytes rand = 1;\n  optional bytes pubkey = 2;\n  optional string exchanges = 3;\n  optional string ciphers = 4;\n  optional string hashes = 5;\n}\n\nmessage Exchange {\n  optional bytes epubkey = 1;\n  optional bytes signature = 2;\n}";